import {useMutation} from '@tanstack/react-query';
import {useCountryLang} from "../hooks/useCountryLang";
import {useEffect, useState} from "react";
import styled from "styled-components";
import Button from "./Button";
import {useRouter} from "next/router";
import {useMessages} from "../hooks/useMessages";
import {request} from "../shared/httpInterceptor";
import {getTheme} from "../shared/themeUtils";
import validator from 'validator';

const Contain = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: ${getTheme("space.3")};
  
  .label {
    color: ${getTheme("colors.secondaryFont")};
      font-weight: bold;
  }
  
  .input-section {
    margin-top: ${getTheme("space.1")};
    display: flex;
  }
  
  input {
    width: 80%;
    max-width: 250px;
    padding: ${getTheme("space.1")} ${getTheme("space.2")};
    border: 1px solid ${getTheme("colors.primary")};
    border-bottom-left-radius: ${getTheme("borderRadius")};
    border-top-left-radius: ${getTheme("borderRadius")};
  }
  
  button {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
    display: flex;
  }

  @media (max-width: ${getTheme("breakpoints.2")}) {
    justify-content: center;
      .input-section {
        justify-content: center;
      }
  }
`

const NewsletterSubscribe = () => {
  const countryLang = useCountryLang()
  const [showConfirmation, setShowConfirmation] = useState(false)
  const [confirmationMessage, setConfirmationMessage] = useState("")
  const [emailInput, setEmailInput] = useState("")
  const router = useRouter()
  const [placeholder, setPlaceholder] = useState("")
  const messagesQuery = useMessages()

  useEffect(() => {
    setConfirmationMessage("")
    setShowConfirmation(false)

    if (messagesQuery.data) {
      setPlaceholder(messagesQuery.data.messages["subscribe-to-our-newsletter"])
    }
  }, [router, messagesQuery.data])

  const addMutation = useMutation(async (email: string) => {
    const body = {
      email: email
    }
    const res = await request({url: `/${countryLang}/newsletterSubscribe`, data: body, method: 'post'})
    setConfirmationMessage(res.data.message)
    setShowConfirmation(true);
    setEmailInput("")
  })

  const handleSubmit = () => {
    const validEmail = validator.isEmail(emailInput);
    if (validEmail) {
      addMutation.mutate(emailInput);
    }
  }

  return (
    <>
    <Contain>
      <span className="label">{placeholder}</span>
      <div className="input-section">
        {messagesQuery.data && <input type="text"
             onChange={(e) => setEmailInput(e.target.value.trim())}
             value={emailInput}
             placeholder={messagesQuery.data.messages["email"]}
      />}
      {messagesQuery.data && <Button variant={"primary"} onClick={handleSubmit}>{messagesQuery.data.messages["submit"]}</Button>}
      </div>
    </Contain>
      {showConfirmation &&
        <div className="mt-2">{confirmationMessage}</div>
      }
    </>
  )
}

export default NewsletterSubscribe;